import Enums from "../../../../utils/Enums";

const GDBenefits = {
  headers: [
    {
      title: ``,
      mandatory: true,
      attributes: {
        style: {
          width: 10
        }
      }
    },
    {
      title: `Benefits / Plan Type`,
      mandatory: true,
      attributes: {
        style: {
          width: "40%"
        }
      }
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>1</strong>`
        },
        {
          data: `<strong>IN-HOSPITAL BENEFITS:</strong>
                <br><b>Room & Board</b> <i>(Including ICU & HDW)</i>
                <br><br><b>Other In-Hospital Benefits</b>
                <br><br><b>Deductible</b>`
        },
        {
          data: `
                <br>(As Per Basic Group Hospital & Surgical Plan)
                <br><br>Eligible expenses as per Basic H & S
                <br><br>(Basic Group Hospital & Surgical Plan)
                `
        },
        {
          data: `
                <br>(As Per Basic Group Hospital & Surgical Plan)
                <br><br>Eligible expenses as per Basic H & S
                <br><br>(Basic Group Hospital & Surgical Plan)
                `
        },
        {
          data: `
                <br>(As Per Basic Group Hospital & Surgical Plan)
                <br><br>Eligible expenses as per Basic H & S
                <br><br>(Basic Group Hospital & Surgical Plan)
                `
        },
        {
          data: `
                <br>(As Per Basic Group Hospital & Surgical Plan)
                <br><br>Eligible expenses as per Basic H & S
                <br><br>(Basic Group Hospital & Surgical Plan)
                `
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>2</strong>`
        },
        {
          data: `
                <b>Daily Parental Accommodation</b>
                <br><b>(max. 120 days per disability)</b>
                <br><br><b>Daily Home Nursing</b>
                <br><b>(max. 30 days per disability)</b>
                <br><br><b>HIV due to Blood Transfusion and Occupational Acquired HIV</b>
                <br><b>(max. per policy year)</b>
                `
        },
        {
          data: `
                $100 per day
                <br>
                <br><br>$100 per day
                <br>
                <br><br>$10,000
                <br>
                `
        },
        {
          data: `
                $100 per day
                <br>
                <br><br>$100 per day
                <br>
                <br><br>$10,000
                <br>
                `
        },
        {
          data: `
                $100 per day
                <br>
                <br><br>$100 per day
                <br>
                <br><br>$10,000
                <br>
                `
        },
        {
          data: `
                $100 per day
                <br>
                <br><br>$100 per day
                <br>
                <br><br>$10,000
                <br>
                `
        }
      ]
    },
    {
      id: 3,
      columns: [
        {
          data: `<strong>3</strong>`
        },
        {
          data: `<strong>CO-INSURANCE:</strong>
                <br><br><b>Employee</b>
                <br><br><b>Subject to Overall Maximum</b>
                <br><b>Benefit Payable Per Disability</b>`
        },
        {
          data: `<br>
                <br>20%
                <br><br>
                <br><b>$60,000</b>`
        },
        {
          data: `<br>
                <br>20%
                <br><br>
                <br><b>$60,000</b>`
        },
        {
          data: `<br>
                <br>20%
                <br><br>
                <br><b>$120,000</b>`
        },
        {
          data: `<br>
                <br>20%
                <br><br>
                <br><b>$60,000</b>`
        }
      ]
    }
  ],
  footnotes: []
};

let GDPremium = {
  headers: [
    {
      title: `Plan Type`,
      mandatory: true
    },
    {
      title: `Plan 1`,
      tier: 1
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>Annual Premium</strong>`
        },
        {
          data: `S$ 285.00`
        }
      ]
    }
  ],
  footnotes: []
};

let Occupational = {
  title: `Occupational`,
  headers: [
    {
      title: `Class`,
      mandatory: true
    },
    {
      title: `Occupations`,
      mandatory: true
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>Class 1</strong>`
        },
        {
          data: `Clerical, administrative or other similar non-hazardous occupations`
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>Class 2</strong>`
        },
        {
          data: `Occupations where some degree of risk is involved, e.g. supervision of manual workers, totally administrative job in an industrial environment`
        }
      ]
    },
    {
      id: 3,
      columns: [
        {
          data: `<strong>Class 3</strong>`
        },
        {
          data: `Occupations involving regular light to medium manual work but no substantial hazard which may increase the risk of sickness or accident`
        }
      ]
    },
    {
      id: 4,
      columns: [
        {
          data: `<strong>Class 4</strong>`
        },
        {
          data: `<strong>Not covered</strong>`
        }
      ]
    }
  ],
  footnotes: []
};

//   ----------------------------------------------------------------------
const GP = {
  id: 1,
  code: "GSMM",
  label: `Group Supplementary Major Medical (GSMM)`,
  types: [
    {
      id: 1,
      order: 1,
      type: Enums.PLANS_TYPE.BENEFITS,
      label: "Plans by Benefits",
      data: [GDBenefits]
    },
    {
      id: 2,
      order: 2,
      type: Enums.PLANS_TYPE.PREMIUMS,
      label: "Plans by Premium (inclusive of 7% GST)",
      data: [GDPremium, Occupational]
    }
  ]
};

export default GP;
